import React from 'react';
import { DisplayStringTrans, useDisplayStringValue } from '@gamiphy/react-i18n';
import {
  AppMission, AppMissionCategoryPopulated, CategoriesKeys, Category,
} from '@gamiphy/bl/mission';
import { ProductApi } from '@gamiphy/gamix-modules/product';
import { Product, ProductCategory } from '@gamiphy/bl/product';
import { Box, Tooltip, Typography } from '@mui/material';

type Props = {
  mission: AppMission | AppMissionCategoryPopulated
  category: Category
}

const MissionTitle: React.FC<Props> = ({
  mission,
  category,
}) => {
  const [product, setProduct] = React.useState<Product>();
  const [productCategory, setProductCategory] = React.useState<ProductCategory>();

  // Get mission product if mission of type specific product
  React.useEffect(() => {
    switch (category.key) {
      case CategoriesKeys.specificProduct:
        if (mission.requirements.constraints?.[0].value) {
          void ProductApi.getExternalProduct(mission.requirements.constraints[0].value)
            .then((p) => setProduct(p));
        }
        break;
      case CategoriesKeys.specificCategory:
        if (mission.requirements.constraints?.[0].value) {
          void ProductApi.getProductCategory(mission.requirements.constraints[0].value)
            .then((c) => setProductCategory(c));
        }
        break;
      default:
      // do-nothing
    }
  }, [category, mission]);

  return (
    <Tooltip
      title={(
        <Typography fontSize={12}>
          <DisplayStringTrans
            displayString={mission.title}
            count={mission.requirements.occurrences}
            values={{
              requirements: mission.requirements,
              productName: useDisplayStringValue(product?.name),
              categoryName: productCategory?.name ?? productCategory?.id,
            }}
          />
        </Typography>
      )}
      placement="top"
    >
      <Box>
        <DisplayStringTrans
          displayString={mission.title}
          count={mission.requirements.occurrences}
          values={{
            requirements: mission.requirements,
            productName: useDisplayStringValue(product?.name),
            categoryName: productCategory?.name ?? productCategory?.id,
          }}
        />
      </Box>
    </Tooltip>
  );
};

export default MissionTitle;
